import { render } from "./TrackAddStock.vue?vue&type=template&id=2c9ae9d9&scoped=true"
import script from "./TrackAddStock.vue?vue&type=script&lang=js"
export * from "./TrackAddStock.vue?vue&type=script&lang=js"

import "./TrackAddStock.vue?vue&type=style&index=0&id=2c9ae9d9&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9ae9d9"]])

export default __exports__